import { render, staticRenderFns } from "./security.vue?vue&type=template&id=42b3a867&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"
import style0 from "./security.vue?vue&type=style&index=0&id=42b3a867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3a867",
  null
  
)

export default component.exports